import * as React from 'react';
import {useEffect, useRef} from 'react';
import {CornerstoneBridge} from '../../../utilities/MWCornerstoneBridge';

// mobile web FlutterDMLRenderer duplicated from DomoWeb

export const FlutterDMLRenderer = ({
                                     dmlCardDefinition,
                                     isEditor,
                                     queryOverrides,
                                     componentStyleId,
                                     canvasBackgroundColor,
                                     theme,
                                     chartColorPaletteJson,
                                   }) => {
  const domRef = useRef();
  const viewIdRef = useRef();

  const apiRef = useRef();

  useEffect(() => {
    apiRef.current && apiRef.current.updateComponentStyle(componentStyleId);
  }, [componentStyleId]);

  useEffect(() => {
    apiRef.current && apiRef.current.updateCanvasBackgroundColor(canvasBackgroundColor);
  }, [canvasBackgroundColor]);

  // const isDefaultThemeNotLoaded = !dataAppId && defaultThemeLoadState !== 'LOADED_SUCCESS';
  const isDefaultThemeNotLoaded = false;

  useEffect(() => {
    if (!domRef.current || isDefaultThemeNotLoaded) {
      return;
    }
    (async () => {
      try {
        if (viewIdRef.current) {
          await CornerstoneBridge.removeView(viewIdRef.current);
        }
        viewIdRef.current = await CornerstoneBridge.addView(domRef.current, {
          type: 'dml',
          dmlCardDefinitionJson: JSON.stringify(dmlCardDefinition),
          themeJson: theme ? JSON.stringify(theme) : undefined,
          chartColorPaletteJson,
          queryOverridesJson: JSON.stringify(queryOverrides),
          componentStyleJson: componentStyleId,
          canvasBackgroundColorJson: canvasBackgroundColor,
          isEditor: false,
          onRendererReady: (api) => {
            apiRef.current = api;
          },
          onForwardedEvent: () => {
            // no-op
          },
        });
      } catch (e) {
        console.error(e);
      }
    })();

    return () => {
      if (viewIdRef.current) {
        (async () => {
          try {
            await CornerstoneBridge.removeView(viewIdRef.current);
          } catch (e) {
            console.error(e);
          }
        })();
      }
    };
  }, [dmlCardDefinition, canvasBackgroundColor, isDefaultThemeNotLoaded]);

  useEffect(() => {
    apiRef.current && apiRef.current.updateQueryOverrides(JSON.stringify(queryOverrides));
  }, [queryOverrides]);

  return (
    <div
      id={isEditor ? 'flutter-dml-editor' : undefined}
      style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      ref={domRef}
    />
  );
};
